import { USER_STATUS_CHANGE } from "./types";

export const changeUserStatus = (updatedStatus, updatedStatusTime) => (
  dispatch
) => {
  dispatch({
    type: USER_STATUS_CHANGE,
    payload: {
      updatedStatus: updatedStatus,
      updatedStatusTime: updatedStatusTime,
    },
  });
};
